function isArray(value) {
    return Array.isArray(value);
}

export { isArray };
